var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
/**
 * @packageDocumentation
 * @module Object
 */
/* eslint-disable complexity */
/* eslint-disable max-params */
import { EMPTY_OBJECT } from '../../constant';
import { mergeIfChanged } from './mergeIfChanged';
/**
 * Immutably sets a value in an object or array at a given path.
 *
 * @param {any} values
 * @param {string[]} path
 * @param {any} value
 * @param {boolean} mergeAtTarget
 *
 * @return {any}
 */
export var setInBaseFunction = function (values, path, value, mergeAtTarget) {
    var _a;
    var nextPos = path[0];
    var isArray = Array.isArray(values);
    if (nextPos === undefined) {
        // We have reached the end just return the value
        if (mergeAtTarget) {
            return mergeIfChanged(values, value);
        }
        return value;
    }
    if (isArray) {
        if (values[nextPos] === undefined) {
            throw Error("Item not defined at position " + nextPos);
        }
        var newValue_1 = setInBaseFunction(values[nextPos], path.slice(1), value, mergeAtTarget);
        if (newValue_1 !== values[nextPos]) {
            var result = __spread(values);
            result[nextPos] = newValue_1;
            return result;
        }
        return values;
    }
    // We only want objects at the point otherwise we are replacing the value here
    var subObject = values[nextPos] !== undefined && typeof values[nextPos] === 'object'
        ? values[nextPos]
        : EMPTY_OBJECT;
    var newValue = setInBaseFunction(subObject, path.slice(1), value, mergeAtTarget);
    if (newValue !== values[nextPos]) {
        return __assign(__assign({}, values), (_a = {}, _a[nextPos] = setInBaseFunction(subObject, path.slice(1), value, mergeAtTarget), _a));
    }
    return values;
};
//# sourceMappingURL=setInBaseFunction.js.map